import ContextualToolbar from "../Navigation/ContextualToolbar/ContextualToolbar";
import Header from "../Navigation/Header/Header";
import MainToolbar from "../Navigation/MainToolbar/MainToolbar";
import { AlternateTopboxModal } from "../Blocks/Modals/AlternateTopboxModal/AlternateTopboxModal";
import { RightSidebar } from "../Navigation/RightSidebar/RightSidebar";
import { RightSidebarSlot } from "@/appComponents/Blocks/Composites/AppLayout/RightSidebarSlot";
import { Globals } from "@coreapp/CoreApp/Globals";
import { ErrorBoundary } from "../Blocks/Utils/ErrorBoundary/ErrorBoundary";
import { enumUIModes } from "@coreapp/constants";
import { useDocumentLoader } from "@/hooks/useDocumentLoader";
import { useRouteState } from "@/hooks/useRouteState";
import { GetDoc } from "@/Utils/StateLib";
import { useTabularDisplayContext } from "@/providers/TabularDisplayProvider";
import PlanningTabularPage from "./planning/Tabular";
import DirectoryPage from "./directory";
import ReportsPage from "./reports";
import { MainContainer } from "../Blocks/Utils/MainContainer";
import CentralizedModalContainer from "../Blocks/Utils/CentralizedModalContainer/CentralizedModalContainer";
import PlanningTabularProvider from "@/providers/PlanningTabularProvider";
import PlanApprovalStatusAlert from "../Blocks/ChartAlerts/PlanApprovalStatusAlert/PlanApprovalStatusAlert";
import PlanStatusAlert from "../Blocks/ChartAlerts/PlanStatusAlert/PlanStatusAlert";
import BoxStyleEditorAlert from "@/appComponents/Blocks/ChartAlerts/BoxStyleEditorAlert/BoxStyleEditorAlert";
import { Flex } from "@theorgchartdev/storybook";
import { useNavigationContext } from "@/providers/NavigationProvider";
import PhoneToolbar from "@/appComponents/Navigation/PhoneToolbar/PhoneToolbar";

const IndexPage = () => {
  useDocumentLoader();

  const { mode } = useRouteState();
  const { isTabularDisplay, isDirectoryDisplay } = useTabularDisplayContext();
  const { isPhoneLayout } = useNavigationContext();

  if (isDirectoryDisplay) {
    return <DirectoryPage />;
  }
  if (mode === "reports") {
    return <ReportsPage />;
  }

  const currentUIMode = Globals._uiConfig.GetUIMode();
  const doc = GetDoc();
  const isPlanningPosMgmtTabularDisplay =
    currentUIMode === enumUIModes.planning && doc?.IsPositionDocument() && isTabularDisplay;

  const renderHeader = () => {
    if (isPlanningPosMgmtTabularDisplay || isPhoneLayout) {
      return null;
    }
    return (
      <div className="appHeader">
        <ErrorBoundary>
          <Header />
        </ErrorBoundary>
        <ErrorBoundary>
          <MainToolbar />
        </ErrorBoundary>
      </div>
    );
  };

  const renderMain = () => {
    if (isPlanningPosMgmtTabularDisplay) {
      return (
        <CentralizedModalContainer show={true}>
          <MainContainer>
            <PlanningTabularProvider>
              <PlanningTabularPage />
            </PlanningTabularProvider>
          </MainContainer>
        </CentralizedModalContainer>
      );
    }

    return (
      <>
        <div style={{ position: "relative" }}>
          {!isPhoneLayout && <ContextualToolbar />}
          <Flex direction="column" alignItems="center" className="ocn-chart-alert-wrapper">
            <PlanApprovalStatusAlert />
            <PlanStatusAlert className="ocn-plan-locked-alert-overlay" />
            <BoxStyleEditorAlert />
          </Flex>
        </div>
        {!isPhoneLayout && (
          <RightSidebarSlot>
            <ErrorBoundary>
              <RightSidebar />
            </ErrorBoundary>
          </RightSidebarSlot>
        )}
      </>
    );
  };

  return (
    <>
      <AlternateTopboxModal />
      {renderHeader()}
      {renderMain()}
      {isPhoneLayout && <PhoneToolbar />}
    </>
  );
};

export default IndexPage;
